<div>
	<div class="text-base mb-6">
		<p class="inline text-base" [innerHTML]="'cookie.description' | translate"></p>
		<a
			[href]="'cookie.imprint_link' | translate"
			target="_blank"
			class="text-primary-900 text-base"
			>{{ 'cookie.imprint' | translate }}</a
		>
	</div>

	<span class="font-semibold">{{ 'cookie.subline' | translate }}</span>
	<p class="text-base">{{ 'cookie.subtext' | translate }}</p>
</div>
